import React, { createElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { HeroSection } from './sections/HeroSection';
import { WhatYouGetSection } from './sections/WhatYouGetSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { ResultsSection } from './sections/ResultsSection';
import { WhatToExpectSection } from './sections/WhatToExpectSection';
import { MentorSection } from './sections/MentorSection';
import { BonusesSection } from './sections/BonusesSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { NewFooter } from './NewFooter';
export const LandingPage = () => {
  const targetDate = new Date('2025-12-07T09:00:00');
  const checkoutUrl = 'https://whop.com/danycredit/dominatucredito/';
  return <>
      <Helmet data-id="element-19">
        <script data-id="element-20">
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '874241008372236');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript data-id="element-21">
          {`<img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=874241008372236&ev=PageView&noscript=1"
          />`}
        </noscript>
      </Helmet>
      <div className="min-h-screen bg-white" data-id="element-22">
        <HeroSection targetDate={targetDate} checkoutUrl={checkoutUrl} data-id="element-23" />
        <WhatYouGetSection data-id="element-24" />
        <TestimonialsSection checkoutUrl={checkoutUrl} data-id="element-25" />
        <ResultsSection data-id="element-26" />
        <WhatToExpectSection checkoutUrl={checkoutUrl} data-id="element-27" />
        <MentorSection checkoutUrl={checkoutUrl} data-id="element-28" />
        <BonusesSection data-id="element-29" />
        <FinalCTASection checkoutUrl={checkoutUrl} data-id="element-30" />
        <NewFooter data-id="element-31" />
      </div>
    </>;
};